import { Layout } from "../UI/Layout/Layout.tsx";
import { ScreenTitleBlock } from "../UI/Layout/ScreenTitleBlock.tsx";
import { Card } from "../UI/Card.tsx";
import {
  OneOnOneAssignmentPdfForm,
  OneOnOneAssignmentPdfFormInputs,
} from "./OneOnOneAssignmentPdfForm.tsx";
import { useCreateOneOnOneAssignmentPdf } from "./useCreateOneOnOneAssignmentPdf.ts";
import { useNavigate } from "react-router-dom";
import { ApolloError } from "@apollo/client";
import { useMessagePopupController } from "../UI/MessagePopup/useMessagePopupController.ts";
import { ErrorMessagePopup } from "../UI/MessagePopup/ErrorMessagePopup.tsx";
import { BreadCrumbsWrapper } from "../UI/Layout/BreadCrumbsWrapper.tsx";
import { BreadCrumbsItem } from "../UI/Layout/BreadCrumbsItem.tsx";
import { AllProgressCheckPdfScreenPath } from "../ProgressCheckPdf/paths.ts";
import { useToAllProgressCheckPdfs } from "../ProgressCheckPdf/useToAllProgressCheckPdfs.ts";

export function CreateOneOnOneAssignmentPdfScreen() {
  const { create } = useCreateOneOnOneAssignmentPdf();
  const navigate = useNavigate();
  const { toAllProgressCheckPdfs } = useToAllProgressCheckPdfs();
  const { show, title, description, showPopup } = useMessagePopupController(
    4 * 1000,
  );

  async function onSave(input: OneOnOneAssignmentPdfFormInputs) {
    try {
      await create({
        assignmentNumber: input.assignmentNumber,
        level: input.level,
        oneOnOneLessonType: input.oneOnOneLessonType,
        pdfUrl: input.pdfUrl,
        userGroupId: input.userGroupId,
        businessEnglishObjective: input.businessEnglishObjective,
      });
    } catch (e) {
      const error = e as ApolloError;
      showPopup("Error", error?.message ?? "Unknown error");
      return;
    }

    navigate(AllProgressCheckPdfScreenPath);
  }

  return (
    <>
      <ErrorMessagePopup title={title} description={description} show={show} />
      <Layout>
        <Card>
          <ScreenTitleBlock
            title={"New 1on1 Assignment Pdf"}
            breadCrumbs={
              <BreadCrumbsWrapper>
                <BreadCrumbsItem
                  title={"Course PDFs"}
                  onClick={toAllProgressCheckPdfs}
                />
                <BreadCrumbsItem title={"New"} />
              </BreadCrumbsWrapper>
            }
          />
        </Card>
        <div className={"mt-4"}>
          <Card>
            <OneOnOneAssignmentPdfForm onSave={onSave} />
          </Card>
        </div>
      </Layout>
    </>
  );
}
